import {
  Box,
  Container, FormControl,
  FormHelperText, Text, useToast, VStack
} from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import PasswordInput from "components/Input/PasswordInput";
import constant from "config/constant";
import useAuth from "hooks/useAuth";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Recaptcha from "react-google-recaptcha";
import { useHistory, useLocation } from "react-router-dom";
import { useResetPasswordMutation } from "services/arbitraryApi";






const ResetPassword = () => {
  const toast = useToast();
  const history = useHistory();
  const location = useLocation();
  const { logout } = useAuth();

  const [passwords, setPasswords] = useState({});

  const searchParams = new URLSearchParams(location.search);
  const [params] = useState(searchParams.toString());
  const [loading, setLoading] = useState(false);

  const recaptchaInstanceRef = useRef();

  const passwordPattern =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

  const [resetPassword, { isLoading, isSuccess, isError, error, data }] =
    useResetPasswordMutation();

  const getError = (error) => {
    function isObj(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
    const value = isObj(error) ? Object.values(error)[0] : error;
    return value ?? "An unexpected error occurred";
  };

  const handlePasswords = (input) => {
    setPasswords({ ...passwords, ...input });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (navigator.onLine === true) {
        setLoading(true);
        const captcha = await recaptchaInstanceRef.current?.executeAsync();
        //   const reqData = { code: pin, captcha };
        const reqData = {
          params,
          password: passwords?.new,
          confirmPassword: passwords?.new,
          humanKey: captcha,
        };

        const response = await resetPassword(reqData);

        if (response) {
          history.push(constant.PAGES.LOGIN);
        }
      } else {
        // console.log(error, "errrrr");
        toast({
          position: "bottom-right",
          title: "Network Error!!",
          description: "Please check your network connection",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isSuccess && data) {
      // console.log("PASSWORD RESET RESULT", isSuccess, data);
      recaptchaInstanceRef.current?.reset();

      //   dispatch(hydrateToken(data.token))
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Password successfully changed.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      history.replace(constant.PAGES.LOGIN);
    }

    if (isError && error) {
      // console.log("PASSWORD RESET ERROR", error);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });

      //   if (toLower(error?.data?.error).includes("no phone number")) {
      //     history.push(`${constant.PAGES.PHONE_NUMBER}?email=${email}`);
      //   }
    }
  }, [isSuccess, data, isError, error, history, toast]);

  const isPasswordsInvalid = useMemo(
    () => passwords?.confirm && passwords?.new !== passwords?.confirm,
    [passwords]
  );

  const isPasswordValid = useCallback(
    (password) => password && RegExp(passwordPattern).test(password),
    // eslint-disable-next-line
    []
  );

  const isDisabled = useMemo(
    () =>
      !(
        passwords?.new &&
        passwords?.confirm &&
        isPasswordValid(passwords?.new) &&
        isPasswordValid(passwords?.confirm)
      ) ||
      isPasswordsInvalid ||
      isLoading,
    [passwords, isLoading, isPasswordValid, isPasswordsInvalid]
  );

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="lg">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Box
              w={["100px", "initial"]}
              as={Logo}
              onClick={() => {
                logout();
                history.replace("/");
              }}
            />
            {/* <Heading as="h3" fontSize={["24px", "32px"]}>
              Welcome
            </Heading> */}
            <Text
              textAlign="center"
              fontSize={["32px", "3xl"]}
              mt="24px !important">
              Reset Password
            </Text>
            <Text
              textAlign="center"
              fontSize={["sm", "md"]}
              color="#4e4b66"
              //   mt="24px !important"
            >
              Create a new password to proceed
            </Text>
          </VStack>

          <Box as="form" mt="50px" onSubmit={handleSubmit}>
            <VStack>
              <FormControl>
                <PasswordInput
                  isRequired
                  isInvalid={passwords?.new && !isPasswordValid(passwords?.new)}
                  pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
                  minW="100%"
                  placeholder="New password"
                  value={passwords?.new ?? ""}
                  onChange={(e) => handlePasswords({ new: e.target.value })}
                />

                {passwords?.new && !isPasswordValid(passwords?.new) && (
                  <FormHelperText fontSize="xs" color="red.400">
                    Password must have at least one uppercase letter, and number
                    and a special character
                  </FormHelperText>
                )}
              </FormControl>

              <FormControl mt="20px !important">
                <PasswordInput
                  isRequired
                  pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
                  isInvalid={
                    (passwords?.confirm &&
                      !isPasswordValid(passwords?.confirm)) ||
                    isPasswordsInvalid
                  }
                  minW="100%"
                  placeholder="Confirm new password"
                  value={passwords?.confirm ?? ""}
                  onChange={(e) => handlePasswords({ confirm: e.target.value })}
                />

                {passwords?.confirm && !isPasswordValid(passwords?.confirm) && (
                  <FormHelperText fontSize="xs" color="red.400">
                    Password must have at least one uppercase letter, and number
                    and a special character
                  </FormHelperText>
                )}
                {isPasswordValid(passwords?.confirm) && isPasswordsInvalid && (
                  <FormHelperText fontSize="xs" color="red.400">
                    Passwords do not match
                  </FormHelperText>
                )}
              </FormControl>

              <Recaptcha
                ref={recaptchaInstanceRef}
                sitekey={process.env.REACT_APP_RECAPTCHA}
                size={"invisible"}
              />

              <Button
                disabled={isDisabled}
                isLoading={loading}
                minW="100%"
                minH="56px"
                fontWeight="normal"
                mt="30px !important"
                type="submit">
                Create
              </Button>
            </VStack>
          </Box>
        </Box>
      </Container>
    </VStack>
  );
};

export default ResetPassword;
